import { empty as observableEmpty, Observable, OperatorFunction } from 'rxjs';

import { catchError, delay, filter, map, pluck, retryWhen, scan, withLatestFrom } from 'rxjs/operators';

import { Action } from '@ngrx/store'
import { HttpResponse } from '@angular/common/http'

import { RequestWrap } from '../models/request-wrap'

import { Predicate } from '@angular/core'

const emptyResult = { results: [] }

/**
 * Handles empty responses(204 No Content) from server.
 */
export function handleEmpty<TModel>(): OperatorFunction<HttpResponse<RequestWrap<TModel>>, RequestWrap<TModel>> {
    return <OperatorFunction<HttpResponse<RequestWrap<TModel>>, RequestWrap<TModel>>>
        map(response => response.status === 204 ? emptyResult : response.body)
}
/**
 * Maps to the payload from the action.
 */
export function toPayload<TPayload>(): OperatorFunction<Action, TPayload> {
    return <OperatorFunction<Action, TPayload>> pluck('payload')
}

/**
 * Uses an observable to filter based on a predicate
 * @param obsWith Observable to use for filtering
 * @param predicate Predicate to use for filtering
 */
export function withPredicateFrom<TObs, TPred>(obsWith$: Observable<TPred>, predicate?: Predicate<TPred>): OperatorFunction<TObs, TObs> {
    predicate = predicate || (val => !!val)

    return (obs: Observable<TObs>) => obs.pipe(
        withLatestFrom(obsWith$, (obs, pred) => ({obs, pred})),
        filter(state => predicate(state.pred)),
        pluck('obs')
    )
}
